import { render, staticRenderFns } from "./TermsForUse.vue?vue&type=template&id=6d7079a4"
import script from "./TermsForUse.vue?vue&type=script&lang=js"
export * from "./TermsForUse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports